import { createContext, useContext } from 'react';
export const default_config = {
    selected: false,
    events_selected: false,
    devices: [],
    ui_settings: {},
    events_general: false,
};
const default_value = {
    dashboard_config: default_config,
    setDashboardConfig: () => { },
};
export const DashboardSettingsContent = createContext(default_value);
export const useDashboardSettings = () => useContext(DashboardSettingsContent);
